import { FunctionComponent, useEffect, useState } from "react"
import { Button, Col, Form, Modal } from "react-bootstrap"
import { Pass, RolePass } from "../data/models.interface"
import ItemSelect from "./ItemSelect"
import { formatDate } from "../utils/AccessControlFormatter"

interface IRolePassModal {
	onHide: () => void
	rolePasses: RolePass[]
	setRolePasses: (p: RolePass[]) => any
	index: number | null
	passes: Pass[]
}
const RolePassModal: FunctionComponent<IRolePassModal> = ({ onHide, rolePasses, setRolePasses, index, passes }) => {
	const [pass, setPass] = useState<Pass>()
	const [startDate, setStartDate] = useState("")
	const [endDate, setEndDate] = useState("")
	const [touched, setTouched] = useState({ passId: false })
	useEffect(() => {
		if (index != null) {
			setPass(passes.find((d) => d.id === rolePasses?.[index]?.passId))
			setStartDate(formatDate(rolePasses?.[index]?.startDate))
			setEndDate(formatDate(rolePasses?.[index]?.endDate))
			setTouched({ passId: false })
		}
	}, [rolePasses, index, passes])
	//
	const errors = validate(pass)
	//
	const save = () => {
		if (index != null) {
			// the modal shouldn't be open if index is undefined
			// show errors on all fields
			setTouched({ passId: true })
			// don't save if there are errors
			if (errors.passError) {
				return
			}
			//
			if (rolePasses == null) {
				rolePasses = [] // in case this is the first row
			} else {
				rolePasses = [...rolePasses] // make sure useState registers it as a new object
			}
			// add a new row if this is an add
			if (rolePasses.length <= index) rolePasses.push({} as RolePass)
			// then we can edit the new or existing row the same way
			rolePasses[index].passId = pass?.id!
			rolePasses[index].passName = pass?.name!
			rolePasses[index].startDate = startDate || "2000-01-01"
			rolePasses[index].endDate = endDate || "2999-12-31"
			setRolePasses(rolePasses) // update state
			onHide() // close the window
		}
	}
	const remove = () => {
		// the modal shouldn't be open if index is undefined
		// the remove button shouldn't be visible if rolePasses is undefined
		if (rolePasses && index != null) {
			rolePasses = [...rolePasses]
			rolePasses.splice(index, 1)
			setRolePasses(rolePasses) // update state
			onHide() // close the window
		}
	}
	//
	return (
		<Modal show={index != null} onHide={onHide}>
			<Modal.Header closeButton={true}>
				<Modal.Title>Edit Pass</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Form.Group className="mb-3" controlId="door">
					<Form.Label>Pass</Form.Label>
					<ItemSelect
						placeholder="--Select a Pass--"
						required
						valueId={pass?.id}
						onChange={setPass}
						onBlur={() => setTouched({ ...touched, passId: true })}
						items={passes}
						convert={(d) => ({ id: d.id, name: d.name })}
						isInvalid={touched.passId && errors.passError != null}
					/>
					<Form.Control.Feedback type="invalid">{errors.passError}</Form.Control.Feedback>
				</Form.Group>
				<Form.Group className="mb-3" controlId="startDate">
					<Form.Label>Start Date</Form.Label>
					<Form.Control type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
				</Form.Group>
				<Form.Group className="mb-3" controlId="endDate">
					<Form.Label>End Date</Form.Label>
					<Form.Control type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
				</Form.Group>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="secondary" disabled={false} onClick={onHide}>
					Cancel
				</Button>
				<Button variant="danger" hidden={index != null && index >= (rolePasses?.length || 0)} onClick={remove}>
					Remove
				</Button>
				<Col></Col>
				<Button variant="primary" disabled={false} onClick={save}>
					OK
				</Button>
			</Modal.Footer>
		</Modal>
	)
}
export default RolePassModal

const validate = (pass?: Pass) => {
	const passError = !pass ? "Pass is required." : null
	return { passError }
}
